import createVueApp from '@/common/createApp'

Styxie.Initializers.MlapProjectsPlaybooks = {
  index: async(props) => {
    const { default: PlaybooksLibrary } = await import('@/vue_widgets/mlap/playbooks/index.vue')
    createVueApp(PlaybooksLibrary, { props })
  },
  show: async(props) => {
    const { default: PlaybookDetail } = await import('@/vue_widgets/mlap/playbooks/show.vue')
    createVueApp(PlaybookDetail, { props })
  }
}
